import { useMediaQuery } from './use-media-query';

/**
 * True when the primary pointer is coarse — the message is being typed on an
 * on-screen keyboard, where Return is the only way to enter a line break and
 * there is no Shift+Enter to fall back on.
 *
 * Composers use this to keep Enter-to-send off touch devices, where Return
 * has to type a newline and the Send button is the only submit path (#2669).
 *
 * Deliberately a capability query rather than a width breakpoint: a narrow
 * desktop window still has a physical keyboard and keeps Enter-to-send, while
 * a tablet in landscape is wider than `lg` and still has no Shift+Enter.
 */
const useOnScreenKeyboard = () => useMediaQuery('(pointer: coarse)');

export { useOnScreenKeyboard };
